import React, { useEffect, useState } from "react";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { Search, Today, CalendarMonth } from "@mui/icons-material";
import DialogLayout from "../../../../partials/content/DialogLayout";
import NumberFormat from "react-number-format";
import { getBalanceSheetReport } from "../../../../services/finance/financeReportService";
import { Table } from "react-bootstrap";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
function BalanceSheet(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [searchByFiscalYear, setSearchByFiscalYear] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriod, setFiscalPeriod] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [totalCurrentAssets, setTotalCurrentAssets] = useState(0);
  const [totalFixedAssets, setTotalFixedAssets] = useState(0);
  const [totalLiabilities, setTotalLiabilities] = useState(0);
  const [totalCurrLiabilities, setTotalCurrLiabilities] = useState(0);
  const [totalEquity, setTotalEquity] = useState(0);
  const [balanceSheet, setBalanceSheet] = useState([]);

  async function getBalanceSheetReportData(
    fiscalYearID = 0,
    fiscalYear = DateTime.now().year,
    fiscalPeriod = DateTime.now().month
  ) {
    const response = await getBalanceSheetReport(
      fiscalYearID,
      fiscalYear,
      fiscalPeriod
    );
    const { data } = response.data;
    const {
      balanceSheet,
      totalCurrentAssets,
      totalFixedAssets,
      totalCurrLiabilities,
      totalLiabilities,
      totalEquity,
    } = data;
    setBalanceSheet(balanceSheet);
    setTotalCurrentAssets(totalCurrentAssets);
    setTotalFixedAssets(totalFixedAssets);
    setTotalCurrLiabilities(totalCurrLiabilities);
    setTotalLiabilities(totalLiabilities);
    setTotalEquity(totalEquity);
  }

  useEffect(() => {
    getBalanceSheetReportData(0, fiscalPeriod.year, fiscalPeriod.month);
  }, [reload]);

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row justify-content-center">
            <div className="col-sm-10 col-md-6 col-lg-4">
              {searchByFiscalYear === true ? (
                <TextField
                  id="fiscalYear"
                  label="Fiscal Year"
                  value={
                    fiscalYear.startMonthName +
                    " " +
                    fiscalYear.year +
                    " - " +
                    fiscalYear.endMonthName +
                    " " +
                    fiscalYear.yearTo
                  }
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYear(true);
                              /*
                              if (currentFiscalYear.ID > 0) {
                                setFiscalYear(currentFiscalYear);
                                getBalanceSheetReportData(
                                  currentFiscalYear.ID,
                                  0,
                                  0
                                );
                              }
                              */
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Search By Fiscal Period">
                          <IconButton
                            type="button"
                            aria-label="SearchBy"
                            onClick={() => {
                              setSearchByFiscalYear(false);
                              /*
                              if (currentFiscalPeriod.ID > 0) {
                                setFiscalPeriod(currentFiscalPeriod);
                                getBalanceSheetReportData(
                                  0,
                                  currentFiscalPeriod.year,
                                  currentFiscalPeriod.month
                                );
                              }
                              */
                            }}
                            edge="end"
                          >
                            <Today />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              ) : (
                <TextField
                  id="fiscalPeriod"
                  label="Fiscal Period"
                  value={fiscalPeriod.monthName + " " + fiscalPeriod.year}
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Search By Fiscal Year">
                          <IconButton
                            type="button"
                            aria-label="SearchBy"
                            onClick={() => {
                              setSearchByFiscalYear(true);
                              if (currentFiscalYear.ID > 0) {
                                setFiscalYear(currentFiscalYear);
                                /*getBalanceSheetReportData(
                                  currentFiscalPeriod.year,
                                  currentFiscalPeriod.month
                                );*/
                              }
                            }}
                            edge="end"
                          >
                            <CalendarMonth />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              )}
            </div>
            <div className="col-sm-2 col-md-2 col-lg-2">
              <button
                className="btn btn-primary"
                onClick={() => {
                  if (fiscalYear.ID > 0) {
                    getBalanceSheetReportData(fiscalYear.ID, 0, 0);
                  } else if (fiscalPeriod.year > 0 && fiscalPeriod.month > 0) {
                    getBalanceSheetReportData(
                      0,
                      fiscalPeriod.year,
                      fiscalPeriod.month
                    );
                  }
                }}
              >
                Load
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-sm-12 col-md-10 col-lg-10">
          <div className="card">
            <Table striped borderless size="sm" responsive="xl">
              <tbody>
                <tr>
                  <td className="bg-primary px-2" colSpan="2">
                    <Typography className="kt-font-bolder text-white">
                      ASSETS
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Current Assets
                    </Typography>
                  </td>
                </tr>
                {balanceSheet && balanceSheet.length > 0
                  ? balanceSheet.map((item, index) => {
                      if (item.categoryID !== 1) {
                        return null;
                      }
                      return (
                        <React.Fragment key={index}>
                          {item.accountBalance && item.accountBalance.length > 0
                            ? item.accountBalance.map(
                                (account, indexAccount) => {
                                  return (
                                    <tr key={indexAccount + index}>
                                      <td className="pl-5 pr-2">
                                        <Typography className="kt-font-bold text-muted">
                                          {account.accountCode +
                                            " - " +
                                            account.accountName}
                                        </Typography>
                                      </td>
                                      <td className="pl-5 pr-2">
                                        <Typography
                                          component="div"
                                          className="kt-font-bold text-muted"
                                        >
                                          <NumberFormat
                                            value={account.amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            renderText={(value) => (
                                              <div className="float-right">
                                                {value}
                                              </div>
                                            )}
                                          />
                                        </Typography>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="pl-5 pr-2">
                    <Typography className="kt-font-bolder">
                      Total Current Assets
                    </Typography>
                  </td>
                  <td className="pl-5 pr-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalCurrentAssets}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Fixed Assets
                    </Typography>
                  </td>
                </tr>
                {balanceSheet && balanceSheet.length > 0
                  ? balanceSheet.map((item, index) => {
                      if (item.categoryID !== 2) {
                        return null;
                      }
                      return (
                        <React.Fragment key={index}>
                          {item.accountBalance && item.accountBalance.length > 0
                            ? item.accountBalance.map(
                                (account, indexAccount) => {
                                  return (
                                    <tr key={indexAccount + index}>
                                      <td className="pl-5 pr-2">
                                        <Typography className="kt-font-bold text-muted">
                                          {account.accountCode +
                                            " - " +
                                            account.accountName}
                                        </Typography>
                                      </td>
                                      <td className="pl-5 pr-2">
                                        <Typography
                                          component="div"
                                          className="kt-font-bold text-muted"
                                        >
                                          <NumberFormat
                                            value={account.amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            renderText={(value) => (
                                              <div className="float-right">
                                                {value}
                                              </div>
                                            )}
                                          />
                                        </Typography>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="pl-5 pr-2">
                    <Typography className="kt-font-bolder">
                      Total Fixed Assets
                    </Typography>
                  </td>
                  <td className="pl-5 pr-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalFixedAssets}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      totalCurrentAssets + totalFixedAssets > 0
                        ? "bg-success"
                        : totalCurrentAssets + totalFixedAssets < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      TOTAL ASSETS
                    </Typography>
                  </td>
                  <td
                    className={`${
                      totalCurrentAssets + totalFixedAssets > 0
                        ? "bg-success"
                        : totalCurrentAssets + totalFixedAssets < 0
                        ? "bg-danger"
                        : "bg-info"
                    } pl-5 pr-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={totalCurrentAssets + totalFixedAssets}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary px-2" colSpan="2">
                    <Typography className="kt-font-bolder text-white">
                      LIABILITIES
                    </Typography>
                  </td>
                </tr>
                {balanceSheet && balanceSheet.length > 0
                  ? balanceSheet.map((item, index) => {
                      if (item.categoryID !== 3) {
                        return null;
                      }
                      return (
                        <React.Fragment key={index}>
                          {item.accountBalance && item.accountBalance.length > 0
                            ? item.accountBalance.map(
                                (account, indexAccount) => {
                                  if (account.accountTypeID === 13) {
                                    return null;
                                  }
                                  return (
                                    <tr key={indexAccount + index}>
                                      <td className="pl-5 pr-2">
                                        <Typography className="kt-font-bold text-muted">
                                          {account.accountCode +
                                            " - " +
                                            account.accountName}
                                        </Typography>
                                      </td>
                                      <td className="pl-5 pr-2">
                                        <Typography
                                          component="div"
                                          className="kt-font-bold text-muted"
                                        >
                                          <NumberFormat
                                            value={account.amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            renderText={(value) => (
                                              <div className="float-right">
                                                {value}
                                              </div>
                                            )}
                                          />
                                        </Typography>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="pl-5 pr-2">
                    <Typography className="kt-font-bolder">
                      Total Current Liabilities
                    </Typography>
                  </td>
                  <td className="pl-5 pr-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalCurrLiabilities}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                {balanceSheet && balanceSheet.length > 0
                  ? balanceSheet.map((item, index) => {
                      if (item.categoryID !== 3) {
                        return null;
                      }
                      return (
                        <React.Fragment key={index}>
                          {item.accountBalance && item.accountBalance.length > 0
                            ? item.accountBalance.map(
                                (account, indexAccount) => {
                                  if (account.accountTypeID !== 13) {
                                    return null;
                                  }
                                  return (
                                    <tr key={indexAccount + index}>
                                      <td className="pl-5 pr-2">
                                        <Typography className="kt-font-bold text-muted">
                                          {account.accountCode +
                                            " - " +
                                            account.accountName}
                                        </Typography>
                                      </td>
                                      <td className="pl-5 pr-2">
                                        <Typography
                                          component="div"
                                          className="kt-font-bold text-muted"
                                        >
                                          <NumberFormat
                                            value={account.amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            renderText={(value) => (
                                              <div className="float-right">
                                                {value}
                                              </div>
                                            )}
                                          />
                                        </Typography>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="pl-5 pr-2">
                    <Typography className="kt-font-bolder">
                      Total Liabilities
                    </Typography>
                  </td>
                  <td className="pl-5 pr-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalLiabilities}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary px-2" colSpan="2">
                    <Typography className="kt-font-bolder text-white">
                      SHAREHOLDER'S EQUITY
                    </Typography>
                  </td>
                </tr>
                {balanceSheet && balanceSheet.length > 0
                  ? balanceSheet.map((item, index) => {
                      if (item.categoryID !== 4) {
                        return null;
                      }
                      return (
                        <React.Fragment key={index}>
                          {item.accountBalance && item.accountBalance.length > 0
                            ? item.accountBalance.map(
                                (account, indexAccount) => {
                                  return (
                                    <tr key={indexAccount + index}>
                                      <td className="pl-5 pr-2">
                                        <Typography className="kt-font-bold text-muted">
                                          {account.accountCode +
                                            " - " +
                                            account.accountName}
                                        </Typography>
                                      </td>
                                      <td className="pl-5 pr-2">
                                        <Typography
                                          component="div"
                                          className="kt-font-bold text-muted"
                                        >
                                          <NumberFormat
                                            value={account.amount}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            renderText={(value) => (
                                              <div className="float-right">
                                                {value}
                                              </div>
                                            )}
                                          />
                                        </Typography>
                                      </td>
                                    </tr>
                                  );
                                }
                              )
                            : null}
                        </React.Fragment>
                      );
                    })
                  : null}
                <tr>
                  <td className="pl-5 pr-2">
                    <Typography className="kt-font-bolder">
                      Total Shareholder's Equity
                    </Typography>
                  </td>
                  <td className="pl-5 pr-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalEquity}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      totalLiabilities + totalEquity > 0
                        ? "bg-success"
                        : totalLiabilities + totalEquity < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      TOTAL LIABILITIES & SHAREHOLDER'S EQUITY
                    </Typography>
                  </td>
                  <td
                    className={`${
                      totalLiabilities + totalEquity > 0
                        ? "bg-success"
                        : totalLiabilities + totalEquity < 0
                        ? "bg-danger"
                        : "bg-info"
                    } pl-5 pr-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={totalLiabilities + totalEquity}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear({
              ID: fiscalYear.ID,
              year: fiscalYear.year,
              yearTo: fiscalYear.yearTo,
              startMonth: fiscalYear.startMonth,
              startMonthName: fiscalYear.startMonthName,
              endMonth: fiscalYear.endMonth,
              endMonthName: fiscalYear.endMonthName,
            });
            setFiscalPeriod({
              ID: 0,
              fiscalYearID: 0,
              year: 0,
              month: 0,
              monthName: "",
              statusID: 0,
            });
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            setFiscalPeriod({
              ID: fiscalPeriod.ID,
              fiscalYearID: fiscalPeriod.fiscalYearID,
              year: fiscalPeriod.year,
              month: fiscalPeriod.month,
              monthName: fiscalPeriod.monthName,
              statusID: fiscalPeriod.statusID,
            });
            setFiscalYear({
              ID: 0,
              year: 0,
              yearTo: 0,
              startMonth: 0,
              startMonthName: "",
              endMonth: 0,
              endMonthName: "",
            });
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default BalanceSheet;
